import { useMemo } from 'react';

import { clockTime, spanText } from '../../../shared/lib/format';
import { Sparkline } from '../../../shared/ui/sparkline';
import { histogram, HISTOGRAM_BINS, type TIssueDetail } from '../../../entities/issue';

interface IIssueHistogramProps {
  issue: TIssueDetail;
  now: number;
  timeZone?: string;
}

// The project's bar chart is the Sparkline primitive (no chart library in the tree); the
// 15-minute bins are the server's own, summed, never interpolated.
export const IssueHistogram = ({ issue, now, timeZone }: IIssueHistogramProps) => {
  const chart = useMemo(() => histogram(issue, now), [issue, now]);
  const total = chart.values.reduce((sum, value) => sum + value, 0);
  const span = spanText(chart.binMs * HISTOGRAM_BINS);

  return (
    <div>
      <p className="mb-inset font-mono text-micro text-faint">
        Failures per {spanText(chart.binMs)}, last {span}
      </p>
      <Sparkline
        values={chart.values}
        tone="danger"
        height="chart"
        gap={3}
        label={`${total.toLocaleString('en-US')} failures in the last ${span}, ${HISTOGRAM_BINS} bars of ${spanText(chart.binMs)}`}
      />
      <div className="mt-2 flex justify-between font-mono text-micro text-faint">
        <span>{clockTime(new Date(chart.start).toISOString(), timeZone)}</span>
        <span>{clockTime(new Date(chart.end).toISOString(), timeZone)}</span>
      </div>
    </div>
  );
};
